import { UserGoalDto, userInfo, UserInfoPlusCredentials } from '@web/common';
import { publicAPI } from '../../../requests';
import { z } from 'zod';

export const requestRegistration = async (
  registrationData: UserInfoPlusCredentials,
  orderIdentifier?: string,
  orderSecret?: string,
) => {
  return await publicAPI.post(`/user`, registrationData, z.void(), {
    headers: {
      'Order-Identifier': orderIdentifier,
      'Order-Secret': orderSecret,
    },
  });
};

export const requestUserData = async (kcToken: string) => {
  return await publicAPI.get(`/user`, userInfo, {
    headers: {
      Authorization: `Bearer ${kcToken}`,
    },
  });
};

export const requestDeleteUser = async (kcToken: string) => {
  return await publicAPI.delete(`/user`, z.string(), {
    headers: {
      Authorization: `Bearer ${kcToken}`,
    },
  });
};

export const requestUpdateUserInfo = async (
  kcToken: string,
  userData: z.input<typeof userInfo>,
) => {
  return await publicAPI.put(`/user`, userData, z.string(), {
    headers: {
      Authorization: `Bearer ${kcToken}`,
    },
  });
};

export const requestProfilePicture = async (kcToken: string) => {
  return await publicAPI.getImage('user/profile-picture', {
    headers: {
      Authorization: `Bearer ${kcToken}`,
    },
  });
};

export const requestUpdateProfilePicture = async (
  kcToken: string,
  picture: Blob,
) => {
  return await publicAPI.put(
    `/user/profile-picture`,
    { picture: picture },
    z.any(),
    {
      headers: {
        Authorization: `Bearer ${kcToken}`,
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const requestUpdateUserGoal = async (
  kcToken: string,
  userGoal: UserGoalDto,
) => {
  return await publicAPI.put(`/user/goal`, userGoal, z.string(), {
    headers: {
      Authorization: `Bearer ${kcToken}`,
    },
  });
};
